import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-background-300 pb-5">
        <div>
          <span className="text-xs font-label tracking-[0.3em] text-primary-600">06 / 分类分区</span>
          <h3 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">按题材分区找</h3>
        </div>
        <p className="max-w-md text-sm leading-6 text-foreground-600">
          不确定从哪进时，先挑一个题材分区，条目数量标在卡里。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.title}
            href="#archive"
            className="group rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 transition-colors hover:border-primary-300 hover:bg-background-50 cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${cat.icon} text-lg`} />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-400 transition-colors group-hover:text-primary-500">
                {cat.count}
              </span>
            </div>
            <h4 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">{cat.title}</h4>
            <p className="mt-1 text-xs md:text-sm leading-5 text-foreground-600">{cat.desc}</p>
          </a>
        ))}
      </div>
    </section>
  );
}